/* tslint:disable */
/* eslint-disable */
/**
 * David Master Api
 * db: david-master
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { UserDTOFromJSON, UserDTOToJSON, } from './UserDTO';
/**
 * Check if a given object implements the UserDTOListBaseResponse interface.
 */
export function instanceOfUserDTOListBaseResponse(value) {
    let isInstance = true;
    return isInstance;
}
export function UserDTOListBaseResponseFromJSON(json) {
    return UserDTOListBaseResponseFromJSONTyped(json, false);
}
export function UserDTOListBaseResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'items': !exists(json, 'items') ? undefined : (json['items'] === null ? null : json['items'].map(UserDTOFromJSON)),
        'count': !exists(json, 'count') ? undefined : json['count'],
    };
}
export function UserDTOListBaseResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'items': value.items === undefined ? undefined : (value.items === null ? null : value.items.map(UserDTOToJSON)),
        'count': value.count,
    };
}
